import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-ipo-details',
    templateUrl: './ipo-details.component.html',
    styleUrls: ['./ipo-details.component.scss'],
    standalone: false
})
export class IpoDetailsComponent implements OnInit {
   @Input() companyProfile: any;

   constructor() {}
   getCurrencyDisplay(value: number | string, country: string): string {
      if (value === null || value === undefined) return 'N/A';

      const symbol = country === 'IN' ? '₹' : '$';

      // Check for range format like "10-15"
      if (typeof value === 'string' && value.includes('-')) {
         const [start, end] = value.split('-').map(Number);
         if (!isNaN(start) && !isNaN(end)) {
            return `${symbol}${start.toLocaleString()}-${symbol}${end.toLocaleString()}`;
         }
         return 'N/A'; // fallback if not a valid number range
      }

      // Handle numeric input
      const numericValue =
         typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(numericValue)) return 'N/A';

      const absValue = Math.abs(numericValue);

      if (absValue >= 1e12) {
         return `${symbol}${(numericValue / 1e12).toFixed(2)} Trillion`;
      } else if (absValue >= 1e9) {
         return `${symbol}${(numericValue / 1e9).toFixed(2)} Billion`;
      } else if (absValue >= 1e6) {
         return `${symbol}${(numericValue / 1e6).toFixed(2)} Million`;
      }

      return `${symbol}${numericValue.toLocaleString(
         country === 'IN' ? 'en-IN' : 'en-US'
      )}`;
   }

   getDateDisplay(profile: any): string {
      const { country, ipo_status } = profile;

      let dateValue: string | undefined;

      if (ipo_status === 'Priced' && (country === 'IN' || country === 'US')) {
         dateValue = profile.ipo_priced_date;
      } else if (country === 'US' && ipo_status === 'Withdrawn' ) {
         dateValue = profile.ipo_withdrwa_date;
      } else if (country === 'US' && ipo_status === 'Upcoming') {
         dateValue = profile.ipo_date;
      } else if (country === 'IN' && ipo_status === 'Upcoming') {
         dateValue = profile.ipo_open_date;
      } else {
         dateValue = profile.ipo_date;
      }

      return dateValue
         ? new Date(dateValue).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
           })
         : 'N/A';
   }

   ngOnInit(): void {}
}
